<!--
 * @Author: xuesong
 * @Date: 2021-04-26 13:46:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-13 14:41:29
 * @Description: 17 结束问诊消息
-->
<template>
  <div class="custom-17" :style="{ backgroundColor: bgColor, color: color }">
    <div class="info-content">
      {{ data.data }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    bgColor: {
      type: String,
      default: '#F5F5F5',
    },
    color: {
      type: String,
      default: '#333',
    },
  },
}
</script>

<style lang="less" scoped>
.custom-17 {
  border-radius: 4px;
  .info-content {
    padding: 10px;
    font-size: 12px;
    font-weight: 500;
  }
}
</style>